import type { ReactNode } from 'react';
import { Link } from 'react-router';

/** Inline code in docs text. */
export function Code({ children }: { children: ReactNode }) {
  return <code>{children}</code>;
}

/** A link to another docs page, optionally to one of its headings. */
export function DocLink({
  page,
  heading,
  children,
}: {
  page: string;
  heading?: string;
  children: ReactNode;
}) {
  return <Link to={`/docs/${page}${heading ? `#${heading}` : ''}`}>{children}</Link>;
}

/** A page's opening sentence, under its title. */
export function Lead({ children }: { children: ReactNode }) {
  return <p className="mz-doc-lead">{children}</p>;
}

/** A small table of rows, in a panel so it scrolls on its own on a phone. */
export function DocTable({ head, rows }: { head: string[]; rows: ReactNode[][] }) {
  return (
    <div className="mz-panel mz-table-wrap">
      <table className="mz-table">
        <thead>
          <tr>
            {head.map((label) => (
              <th key={label} scope="col">
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: fixed rows of a docs table
            <tr key={i}>
              {row.map((cell, j) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: fixed cells of a docs table
                <td key={j}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
